import { render, staticRenderFns } from "./ChatToastification.vue?vue&type=template&id=54331b0e&"
import script from "./ChatToastification.vue?vue&type=script&lang=js&"
export * from "./ChatToastification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports